import React, { ReactElement } from 'react';
import clsx from 'clsx';

interface Props {
  disabled: boolean;
  children: ReactElement;
}

export const Disabled = ({ disabled, children, ...rest }: Props) => {
  return (
    <div
      className={clsx('inline-block', disabled && 'opacity-50 cursor-not-allowed pointer-events-none')}
      aria-disabled={disabled}
      {...rest}
    >
      {children}
    </div>
  );
};
